<template lang="pug">
    div.hz-form(ref="form", :class="{'hz-form-inline': isInline }", @submit.native.prevent="_subForm")
        slot(:labelWidth="labelWidth")
</template>

<script>
    import Emitter from './util/emitter'
    export default {
        name: 'hz-form',
        mixins: [Emitter],
        props: {
            isInline: { type: Boolean, default: false },
            labelWidth: { type: String},
            isInputBlock: { type: Boolean, default: false },
            model: { type: Object, default: function(){ return {} }},
            rules: { type: Object, default: function(){ return {} }}
        },
        provide(){
            return {
                labelWidth: this.isInline ?  (this.labelWidth || 'auto') : (this.labelWidth || "80px"),
                rulesAll: this.rules,
                modelSource: this.model
            }
        },
        watch:{
            model: {
                handler(val){
                    this.broadcast("hz-form-item", 'initModel', val);
                },
                deep: true
            },
            rules: {
                handler(val){
                    this.broadcast("hz-form-item", 'initRules', val);
                    this.resetFields();
                },
                deep: true
            }
        },
        data(){
            return {
                validateObj: {}
            }
        },
        created(){
            this.$on("validate", obj => {
                this.validateObj = Object.assign({}, this.validateObj, obj);
            })
        },
        mounted(){
        },
        methods: {
            validate(cb){
                this.broadcast("hz-form-item", 'validate');
                let result = true;
                for(let key in this.validateObj){
                    if(!this.validateObj[key]){
                        result = false;
                        break;
                    }
                }
                cb && cb(result)
            },
            resetFields(){
                this.validateObj = {};
                this.broadcast("hz-form-item", 'reset');
            },
            _subForm($event) {
                var event = $event || window.event; // for ie

            　　//取消事件相关的默认行为
            　　if(event.preventDefault) event.preventDefault(); //标准技术
            　　if(event.returnValue) event.returnValue = false;

            　　return false; //用于处理对象属性注册的处理程序。
            }
        }
    }
</script>
<style lang="stylus">
    .hz-form-inline
        .hz-form-item
            display: inline-block
            vertical-align: top
            input[type="date"],input[type="text"],input[type="url"],input[type="number"],input[type="password"], input:not([type]), textarea, select, .hzIptResult, .hzSelectContainer
                width: 150px
</style>



// WEBPACK FOOTER //
// src/form.vue